import moment from 'moment';
import Logger from './Logger';

const Filter = {
    getSettingByKey: (key) => {
        const settings = localStorage.getItem('settings');
        if(settings === undefined || settings === null || !settings) {
            return false;    
        }
        const jsonSettings = JSON.parse(settings);
        if(jsonSettings === undefined || jsonSettings === null || !jsonSettings) {
            return false;    
        }
        const result = jsonSettings[key];
        if(result === undefined || result === null || !result) {
            return false;    
        }
        return result;
    },
    getSettingByKeyByOwner: (key, ownerId) => {
        const settings = localStorage.getItem(ownerId + '_settings');
        if(settings === undefined || settings === null || !settings) {
            return false;    
        }
        const jsonSettings = JSON.parse(settings);
        if(jsonSettings === undefined || jsonSettings === null || !jsonSettings) {
            return false;    
        }
        const result = jsonSettings[key];
        if(result === undefined || result === null || !result) {
            return false;    
        }
        return result;
    },
    numberFormat : (number, decimals, dec_point, thousands_sep) => {

        // Ref: https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript

        let n = !isFinite(+number) ? 0 : +number, 
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            toFixedFix = function (n, prec) {
                // Fix for IE parseFloat(0.55).toFixed(0) = 0;
                var k = Math.pow(10, prec);
                return Math.round(n * k) / k;
            },
            s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    },
    displayStockItems: (n) => {
        if(isNaN(n)){
            return n;
        }
        const settings = Filter.getSettingByKey('currencyFormat');
        const decimalPlace = 4;
        const decimalSeparator = settings['decimalSeparator'] || ".";
        const thousandSeparator = settings['thousandSeparator'] || ",";
        
        return Filter.numberFormat(n, decimalPlace, decimalSeparator, thousandSeparator);
    },
    displayCurrency: (n) => {
        if(isNaN(n)){
            return n;
        }
        const settings = Filter.getSettingByKey('currencyFormat');
        const decimalPlace = settings['decimalPlace'] || 2;
        const decimalSeparator = settings['decimalSeparator'] || ".";
        const thousandSeparator = settings['thousandSeparator'] || ",";
        
        return Filter.numberFormat(n, decimalPlace, decimalSeparator, thousandSeparator);
    },
    displayNumber: (n) => {
        if(isNaN(n)){
            return n;
        }
        const settings = Filter.getSettingByKey('currencyFormat');
        const decimalPlace = 0;
        const decimalSeparator = settings['decimalSeparator'] || ".";
        const thousandSeparator = settings['thousandSeparator'] || ",";
        
        return Filter.numberFormat(n, decimalPlace, decimalSeparator, thousandSeparator);
    },
    changeToNameSettings: (type, value, isPercent) => {
        const settings = Filter.getSettingByKey('name');
        if(settings[type] === undefined || settings[type] === null || !settings[type]) {
            return value;
        }
        if(isPercent) {
            return settings[type] + " (%)";
        }
        return settings[type];
    },
    changeToNameSettingsByOwner: (type, value, isPercent, ownerId) => {
        const settings = Filter.getSettingByKeyByOwner('name', ownerId);
        if(settings[type] === undefined || settings[type] === null || !settings[type]) {
            return value;
        }
        if(isPercent) {
            return settings[type] + " (%)";
        }
        return settings[type];
    },
    getStartDateByCutOffTime: (time, configs) => {
        const openTime = configs.openingHour || "00:00:00";
        const cutTimeOff = configs.cutTimeOff || "08:00:00";
        const compare = Filter.compareTime(openTime, cutTimeOff);
        if(compare === 1) {
            return moment((time).format("YYYY-MM-DD " + openTime)).subtract(1, 'days');
        }
        else {
            return  moment((time).format("YYYY-MM-DD " + openTime));
        }
    },
    getEndDateByCutOffTime: (time, configs) => {
        const openTime = configs.openingHour || "00:00:00";
        const cutTimeOff = configs.cutTimeOff || "08:00:00";
        const compare = Filter.compareTime(openTime, cutTimeOff);
        if(compare === 1) {
            return moment((time).format("YYYY-MM-DD " + openTime));
        }
        else {
            return  moment((time).format("YYYY-MM-DD " + openTime)).add(1, 'days');
        }
    },
    getTypeCutOffTime: (configs) => {
        const openTime = configs.openingHour || "00:00:00";
        const cutTimeOff = configs.cutTimeOff || "08:00:00";
        const compare = Filter.compareTime(openTime, cutTimeOff);
        if(compare === 1) {
            return 1;
        }
        else {
            return 2;
        }
    },
    compareTime: (str1, str2) => {
        if(str1 === str2){
            return 0;
        }
        var time1 = str1.split(':');
        var time2 = str2.split(':');
        if(parseInt(time1[0]) > parseInt(time2[0])){
            return 1;
        } else if(parseInt(time1[0]) == parseInt(time2[0]) && parseInt(time1[1]) > parseInt(time2[1])) {
            return 1;
        } else {
            return -1;
        }
    },
    notifyWhenLoadOverDays: (start, end) => {
        let diff = start.diff(end, 'days');
        diff = diff < 0 ? diff * (-1) : diff;
        if(diff >= 45) {
            return false;
        }
        return true;
    },
    notifyWhenLoadOverPeriodDays: (periods) => {
        const DAYS = 180;
        if(periods === undefined || !periods || periods.length <= 0) {
            return true;
        }
        const periodsLenght = periods.length;
        for(let i = 0; i < periodsLenght; i++) {
            const period = periods[i];
            const start = period.realDateRange.start;
            const end = period.realDateRange.end;
            let diff = start.diff(end, 'days');
            diff = diff < 0 ? diff * (-1) : diff;
            if(diff >= DAYS) {
                return false;
            }
        }
        return true;
    },
    getMealTime: (time) => {
        let mealTime = parseInt(time);
        if(mealTime == 0) {
            mealTime = 1;
        }
        const mealTimeSettings = Filter.getSettingByKey('mealTime');
        return mealTimeSettings[mealTime] !== undefined ? mealTimeSettings[mealTime] : "";
    },
    minTwoDigits: (n) => {
        return (n < 10 ? '0' : '') + n;
    },
    sortedMealTime: (mealTimes) => {
        let mealTime = [];

        const mealTimeSettings = Filter.getSettingByKey('mealTime');
        const openingClosingHour = Filter.getSettingByKey('openingClosingTime');
        const openTime = openingClosingHour.openingHour || "00:00:00";
        
        const seperatorTime = openTime.split(':');
        const hour = +seperatorTime[0] || 0;

        let mealTimeWork = {...mealTimeSettings}
        for(let i = hour; i <= 24; i++) {
            let meal = mealTimeWork[i];
            const hourString = Filter.minTwoDigits(i).toString();
            if(meal === undefined) {
                continue;
            }
            if(meal === "") {
                meal = hourString+"hr";
            }
            if(mealTimes.includes(hourString+"hr")) {
                meal = hourString+"hr";
            }
            if(mealTime.includes(meal)) {
                continue; 
            }
            mealTime.push(meal)
        }
        for(let i = 1; i < hour; i++) {
            let meal = mealTimeWork[i];
            const hourString = Filter.minTwoDigits(i).toString();
            if(meal === undefined) {
                continue;
            }
            if(meal === "") {
                meal = hourString+"hr";
            }
            if(mealTimes.includes(hourString+"hr")) {
                meal = hourString+"hr";
            }
            if(mealTime.includes(meal)) {
                continue; 
            }
            mealTime.push(meal)
        }
        return mealTime;
    },
    isJSON: (str) => {
        try {
            return (JSON.parse(str) && !!str);
        } catch (e) {
            return false;
        }
    },
    isJSONToStringtify:(json) => {
        if(typeof json === "array" || typeof json === "object") {
            return JSON.stringify(json);
        }
        else {
            return json;
        }
    },
    getPeriodName: (time, periods) => {
        const timeSeconds = (new Date(time)).getTime();
        const periodsLength = periods.length;
        for(let i = 0; i < periodsLength; i++) {
            const period = periods[i];
            const startTime = new Date(period.realDateRange.start).getTime();
            const endTime = new Date(period.realDateRange.end).getTime();

            if(timeSeconds >= startTime && timeSeconds <= endTime) {
                return period.name;
            }
        }
        return "";
    },
    getPeriodRangeTime: (time, periods) => {
        const timeSeconds = (new Date(time)).getTime();
        const periodsLength = periods.length;
        for(let i = 0; i < periodsLength; i++) {
            const period = periods[i];
            const startTime = new Date(period.realDateRange.start).getTime();
            const endTime = new Date(period.realDateRange.end).getTime();

            if(timeSeconds >= startTime && timeSeconds <= endTime) {
                return {
                    from: moment((period.realDateRange.start)).format("YYYY-MM-DD HH:mm:ss"),
                    to: moment((period.realDateRange.end)).format("YYYY-MM-DD HH:mm:ss"),
                };
            }
        }
        return false;
    },
    periodOverlap: (time, periods, index) => {
        const timeSeconds = (new Date(time)).getTime();
        const periodsLength = periods.length;
        for(let i = 0; i < periodsLength; i++) {
            const period = periods[i];
            const startTime = new Date(period.realDateRange.start).getTime();
            const endTime = new Date(period.realDateRange.end).getTime();
            if(index !== i && timeSeconds >= startTime && timeSeconds <= endTime) {
                return true;
            }
        }
        return false;
    },
    isInPeriods: (timeSeconds, periods) => {
        const periodsLength = periods.length;
        for(let i = 0; i < periodsLength; i++) {
            const period = periods[i];
            const startTime = new Date(period.realDateRange.start).getTime();
            const endTime = new Date(period.realDateRange.end).getTime();

            if(timeSeconds >= startTime && timeSeconds <= endTime) {
                return true;
            }
        }
        return false;
    },
    getDayOffset: (timeSeconds, periods) => {
        const periodsLength = periods.length;
        for(let i = 0; i < periodsLength; i++) {
            const period = periods[i];
            const startTime = new Date(period.realDateRange.start).getTime();
            const endTime = new Date(period.realDateRange.end).getTime();

            if(timeSeconds >= startTime && timeSeconds <= endTime) {
                const momentStart = moment(startTime);
                const momentTimeSeconds = moment(timeSeconds);
                return momentTimeSeconds.diff(momentStart, 'days');
            }
        }
        return "Unknown";
    },
    getInventorySummariesSettings: (type) => {
        const settings = Filter.getSettingByKey('inventorySummary');
        if(settings[type] === undefined || settings[type] === null || !settings[type]) {
            return 0;
        }
        return settings[type] || 0;
    },
    isInWishlist: () => {
        let wishlists = [];
        let path = window.location.pathname;
        path = path.replace("/DevMemberReact", "");
        const wishlistStoreage = localStorage.getItem("wishlists");
        if(wishlistStoreage !== undefined && Filter.isJSON(wishlistStoreage)) {
            wishlists = JSON.parse(wishlistStoreage);
        }
        const wishlistsLength = wishlists.length;
        for(let i = 0; i < wishlistsLength; i++) {
            if(wishlists[i].path === path) {
                return {
                    ...wishlists[i],
                    ["state"]: Filter.isJSON(wishlists[i].state) ? JSON.parse(wishlists[i].state) : {}
                };
            }
        }
        return false;
    },
    converResponseData: (data, type, isSecurity) => {
        let dataInput = data;
        switch(type) {
            case 2:
                const response = new window.Zlib.Gunzip(new window.Uint8Array(dataInput)).decompress();
                let str = "";
                for (let i=0; i < response.byteLength; i++) {
                    str += String.fromCharCode(response[i]);    
                }
                let result = decodeURIComponent(escape(str));
                if(isSecurity !== undefined && isSecurity) {
                    result = Filter.decrypt3DES(result); 
                }
                return JSON.parse(result);
            default:
                return data;
        }
    },
    converResponseType: (type) => {
        switch(type) {
            case 2:
                return {
                    responseType: 'arraybuffer'
                };
            default:
                return {};
        }
    },
    converRequestType: (setMenu, type, isSecurity) => {
        let setMenuInput = setMenu !== undefined && Filter.isJSONToStringtify(setMenu) ? JSON.stringify(setMenu) : "";
        if(isSecurity !== undefined && isSecurity) {
            setMenuInput = Filter.encrypt3DES(setMenuInput); 
        }
        const stringSetMenu = setMenuInput.replace(/[\u0080-\uFFFF]/g, function (match) {
            return '\\u' + ('0000' + match.charCodeAt(0).toString(16)).slice(-4);
        });
        const base64Data = window.btoa(unescape(encodeURIComponent(stringSetMenu)));
        switch(type) {
            case 2:
                let compressData = window.atob(base64Data);
                compressData = compressData.split('').map(function(e) {
                    return e.charCodeAt(0);
                });
                const gzip = new window.Zlib.Gzip(compressData);
                const compressed = gzip.compress();
                const b64 = Buffer.from(compressed).toString('base64');
                if(isSecurity !== undefined && isSecurity) {
                    return {
                        name: "menu.zip.crypt",
                        base64: b64,
                        mimeType: "application/zip"
                    }
                }
                return {
                    name: "menu.zip",
                    base64: b64,
                    mimeType: "application/zip"
                }
            default:
                return {
                    name: "menu.txt",
                    base64: base64Data,
                    mimeType: "application/json"
                };
        }
    },
    // encrypt3DES: (object) => {
    //     return CryptoJS.TripleDES.encrypt(object, process.env.REACT_APP_SECRET).toString();
    // },
    // decrypt3DES: (encrypted) => {
    //     const decrypted = CryptoJS.TripleDES.decrypt(encrypted, process.env.REACT_APP_SECRET);  
    //     return decrypted.toString(CryptoJS.enc.Utf8);
    // },
    convertInventoryUsage: (usages, inventoriesObject) => {
        const inventoryUsages = usages.map((value) => {
            const name = value.name;
            let displayVal = value.value
            if(value.value == 0.5) {
                displayVal = "Unlimited";
            }
            const other = inventoriesObject[value.id] !== undefined && inventoriesObject[value.id].other != undefined && Filter.isJSON(inventoriesObject[value.id].other) ? JSON.parse(inventoriesObject[value.id].other) : {};
            const unit = other !== undefined && other.unit !== undefined ? other.unit : "--";
            const category = value.other !== undefined && value.other.category != undefined ? value.other.category : "--";
            return `${name} ${category ? `(${category})` : null} [${displayVal} - ${unit}]`;
        });
        if(inventoryUsages.length <= 0) {
            return [
                "N/A"
            ]
        }
        return inventoryUsages;
    },
    convertSetUsage: (usages, items, prices, categoriesObject) => {
        let type = 0;
        const setMealItems = usages.filter(value => {
            if(value.type == "set_meal") {
                return true;
            }
            return false;
        }).map((value) => {
            const other = value.other !== undefined && 
                Filter.isJSON(value.other) ? JSON.parse(value.other) : {};

            type = other.set_type || 0;

            const dishSortId = items[value.id] !== undefined && items[value.id].order !== undefined ?  items[value.id].order : 0;
            const priceSortId = prices[other.prices_name] !== undefined && prices[other.prices_name].order !== undefined ?  prices[other.prices_name].order : 0;
            const catSortId = other.cat_set_meal !== undefined && 
                other.cat_set_meal[0] !== undefined && 
                categoriesObject[other.cat_set_meal[0].id] !== undefined &&
                categoriesObject[other.cat_set_meal[0].id].order
                ?  categoriesObject[other.cat_set_meal[0].id].order : 0;

            const sortId = ((catSortId) * 100000) + ((dishSortId) * 1000) + priceSortId;

            let displayVal = value.value;
            if(value.value == 0.5) {
                displayVal = "--";
            }
            let priceName = "";
            let name = value.name;
            if(
                other.prices_name !== undefined &&
                prices[other.prices_name] !== undefined &&
                prices[other.prices_name].name !== undefined 
            ) {
                priceName = "(" + prices[other.prices_name].name + ")";
            }
            let catName = "";
            let itemType = "Inclusive";
            if(
                other !== undefined &&
                other.cat_set_meal !== undefined &&
                other.cat_set_meal[0] !== undefined &&
                other.cat_set_meal[0].name !== undefined
            ) {
                if(other.cat_set_meal[0].min <= 0 && other.cat_set_meal[0].max <= 0) {
                    catName = `${other.cat_set_meal[0].name} [Unlimited]`;
                }
                else {
                    catName = `${other.cat_set_meal[0].name} [${other.cat_set_meal[0].min} - ${other.cat_set_meal[0].max}]`;
                }
            }
            else {
                catName = `${itemType} [${displayVal}]`;
            }
            name = name + " " + priceName;
            return {
                value: `${name} - ${catName}`,
                sortId: sortId
            };
        }).sort((a, b) => {
            return a.sortId - b.sortId
        }).map(value => {
            return value.value;
        });
    
        const setGroupMealItems = usages.filter(value => {
            if(value.type == "group_set_meal") {
                return true;
            }
            return false;
        }).map((value) => {
            const others = value.list_dish !== undefined && 
                value.list_dish.others !== undefined &&
                Filter.isJSON(value.list_dish.others) ? JSON.parse(value.list_dish.others) : [];

            return {
                group: `Group: ${value.name}`,
                value: others.map(other => {
                    
                    const name = items[other.usage_id] !== undefined && items[other.usage_id].name !== undefined ? 
                        items[other.usage_id].name : ""
    
                    const usageOthers = other.usage_other !== undefined && 
                        Filter.isJSON(other.usage_other) ? JSON.parse(other.usage_other) : {};
    
                    const price = prices[usageOthers.prices_name] !== undefined && prices[usageOthers.prices_name].name !== undefined ? 
                        " (" + prices[usageOthers.prices_name].name + ")" : "";

                    const dishSortId = items[other.usage_id] !== undefined && items[other.usage_id].order !== undefined ? items[other.usage_id].order : 0;
                    const priceSortId = prices[usageOthers.prices_name] !== undefined && prices[usageOthers.prices_name].order !== undefined ?  prices[usageOthers.prices_name].order : 0;

                    const catSortId = usageOthers.cat_set_meal !== undefined && 
                        usageOthers.cat_set_meal[0] !== undefined && 
                        categoriesObject[usageOthers.cat_set_meal[0].id] !== undefined &&
                        categoriesObject[usageOthers.cat_set_meal[0].id].order
                        ?  categoriesObject[usageOthers.cat_set_meal[0].id].order : 0;
    
                    const sortId = ((catSortId) * 100000) + ((dishSortId) * 1000) + priceSortId;

                    type = usageOthers.set_type || 0;

                    let displayVal = value.value
                    if(value.value == 0.5) {
                        displayVal = "--";
                    }
                    
                    let catName = "";
                    let itemType = "Inclusive";
                    if(
                        usageOthers !== undefined &&
                        usageOthers.cat_set_meal !== undefined &&
                        usageOthers.cat_set_meal[0] !== undefined &&
                        usageOthers.cat_set_meal[0].name !== undefined
                    ) {
                        if(usageOthers.cat_set_meal[0].min <= 0 && usageOthers.cat_set_meal[0].max <= 0) {
                            catName = `${usageOthers.cat_set_meal[0].name} [Unlimited]`;
                        }
                        else {
                            catName = `${usageOthers.cat_set_meal[0].name} [${usageOthers.cat_set_meal[0].min} - ${usageOthers.cat_set_meal[0].max}]`;
                        }
                    }
                    else {
                        catName = `${itemType} [${displayVal}]`;
                    }
                    return {
                        value: `${name} (${price}) - ${catName}`,
                        sortId: sortId
                    }
                }).sort((a, b) => {
                    return a.sortId - b.sortId
                }).map(value => {
                    return value.value;
                })
            };
        })
        if(setGroupMealItems.length > 0) {
            return [
                type ? "Set Item Group:" : "Set Meal Group:",
                setGroupMealItems[0].group,
                ...setGroupMealItems[0].value
            ];
        }
        if(setMealItems.length > 0) {
            return [
                type ? "Set Item:" : "Set Meal:",
                ...setMealItems
            ];
        }
        return [
            "N/A"
        ]
    },
    convertArrayToObjectInventories: (inventories) => {
        let convertedItems = {};
        const inventoriesLength = inventories.length;
        for(let i = 0; i < inventoriesLength; i++) {
            const item = inventories[i];
            convertedItems = {
                ...convertedItems,
                [item.id]: {
                    ...item,
                }
            };
        }
        return convertedItems;
    },
    convertArrayToObjectCategories: (categories) => {
        let convertedItems = {};
        const categoriesLength = categories.length;
        for(let i = 0; i < categoriesLength; i++) {
            const item = categories[i];
            convertedItems = {
                ...convertedItems,
                [item.id]: {
                    ...item,
                }
            };
        }
        return convertedItems;
    },
    convertCategories: (categories, dishes) => {
        const dishesLength =  dishes.length;
        if(categories.length <= 0) {
            for(let menuIndex = 0; menuIndex < dishesLength; menuIndex++) {
                const dish = dishes[menuIndex];
                if(categories.length <= 0 && dish.list_category){
                    const list_category_length = dish.list_category.length;
                    for(let categoryIndex = 0; categoryIndex < list_category_length; categoryIndex++){			
                        const name = dish.list_category[categoryIndex].name;
                        const id = +(dish.list_category[categoryIndex].id);
                        if(categories.indexOf({
                            name: name
                        }) == -1){
                            categories.push({
                                name: name
                            });						
                        }	
                    }
                }
            }
        }
        let convertedItems = {};
        convertedItems = {
            ...convertedItems,
            ["0"]: {
                ...{
                    id: 0,
                    name: "No Category"
                },
                ["dishes"]: []
            }
        };
        const categoriesLength = categories.length;
        for(let i = 0; i < categoriesLength; i++) {
            const item = categories[i];
            if(item.cat !== "category") {
                continue;
            }
            convertedItems = {
                ...convertedItems,
                [item.id]: {
                    ...item,
                    ["dishes"]: []
                }
            };
        }
        for(let dishI = 0; dishI < dishesLength; dishI++) {
            const dish = dishes[dishI];
            const listCategories = dish.list_category;
            if(listCategories == undefined || listCategories.length <= 0) {
                continue;
            }
            const listCategoriesLength = listCategories.length;
            for(let catI = 0; catI < listCategoriesLength; catI++) {
                const cat = listCategories[catI];
                if(convertedItems[cat.id] == undefined) {
                    convertedItems = {
                        ...convertedItems,
                        ["0"]: {
                            ...convertedItems["0"],
                            ["dishes"]: [
                                ...convertedItems["0"].dishes,
                                dish
                            ]
                        }
                    };
                }
                else {
                    convertedItems = {
                        ...convertedItems,
                        [cat.id]: {
                            ...convertedItems[cat.id],
                            ["dishes"]: [
                                ...convertedItems[cat.id].dishes,
                                dish
                            ]
                        }
                    };
                }
            }
        }
        return Object.values(convertedItems);
    },
    convertOldPriceName: (dishes) => {
        let convertedItems = {};
        const dishesLength = dishes.length;
        for(let menuIndex = 0; menuIndex < dishesLength; menuIndex++) {
            const dish = dishes[menuIndex];
            if(dish.list_prices){
                const list_prices_length = dish.list_prices.length;
                for(let index = 0; index < list_prices_length; index++){			
                    const item = dish.list_prices[index];
                    convertedItems = {
                        ...convertedItems,
                        [item.name]: {
                            ...{
                                name: item.name
                            },
                        }
                    };
                }
            }
        }
        return convertedItems;
    },
    convertPriceName: (prices) => {
        let convertedItems = {};
        const pricesLength = prices.length;
        for(let i = 0; i < pricesLength; i++) {
            const item = prices[i];
            if(item.cat !== "price") {
                continue;
            }
            convertedItems = {
                ...convertedItems,
                [item.id]: {
                    ...item,
                }
            };
        }
        return convertedItems;
    },
    convertDepartment: (departments) => {
        let convertedItems = {};
        const departmentsLength = departments.length;
        for(let i = 0; i < departmentsLength; i++) {
            const item = departments[i];
            if(item.cat !== "department") {
                continue;
            }
            convertedItems = {
                ...convertedItems,
                [item.id]: {
                    ...item,
                }
            };
        }
        return convertedItems;
    },
    convertRatings: (ratings) => {
        let convertedItems = {};
        const ratingsLength = ratings.length;
        for(let i = 0; i < ratingsLength; i++) {
            const item = ratings[i];
            if(item.cat !== "rating") {
                continue;
            }
            convertedItems = {
                ...convertedItems,
                [item.id]: {
                    ...item,
                }
            };
        }
        return convertedItems;
    },
    convertModifiers: (modifiers) => {
        let convertedItems = {};
        const modifiersLength = modifiers.length;
        for(let i = 0; i < modifiersLength; i++) {
            const item = modifiers[i];
            if(item.cat !== "modifier") {
                continue;
            }
            convertedItems = {
                ...convertedItems,
                [item.id]: {
                    ...item,
                }
            };
        }
        return convertedItems;
    },
    convertSets: (sets) => {
        let convertedItems = {};
        const setsLength = sets.length;
        for(let i = 0; i < setsLength; i++) {
            const item = sets[i];
            if(item.cat !== "set") {
                continue;
            }
            convertedItems = {
                ...convertedItems,
                [item.id]: {
                    ...item,
                }
            };
        }
        return convertedItems;
    },
    convertItems: (items) => {
        let convertedItems = {};
        const itemsLength = items.length;
        for(let i = 0; i < itemsLength; i++) {
            const item = items[i];
            convertedItems = {
                ...convertedItems,
                [item.id]: {
                    ...item,
                }
            };
        }
        return convertedItems;
    },
    convertUsers: (userString) => {
        if(userString !== undefined && Filter.isJSON(userString)) {
            const users = JSON.parse(userString);
            if(users.users === undefined) {
                return [];
            }
            return [...users.users];
        }
        return [];
    },
    convertPayments: (paymentString) => {
        if(paymentString !== undefined && Filter.isJSON(paymentString)) {
            const payments = JSON.parse(paymentString);
            if(payments === undefined) {
                return [];
            }
            return [...payments];
        }
        return [];
    },
    convertPromotions: (promotionString) => {
        if(promotionString !== undefined && Filter.isJSON(promotionString)) {
            const promotions = JSON.parse(promotionString);
            if(promotions === undefined) {
                return [];
            }
            return [...promotions];
        }
        return [];
    },
    convertPaymentNoteToObject: (note, defaultVal) => {
        if(note == undefined || !note) {
            return {
                ...defaultVal
            };
        }
        const paymentNoteSplit = note.split("\n");
        const result = paymentNoteSplit.length > 0 ? paymentNoteSplit.filter((val) => {
                if(val.includes("Payment") || val.includes("TrasnId") || val == "") {
                    return false;
                }
                return true;
            })
            .map(x => x.split(':')
            .map(y => y.trim()))
            .reduce((a, x) => {
                a["*" + x[0]] = x[1];
                return a;
            }, {

            }) : {
               ...defaultVal
            };

        return {
            ...result
        };
    },
    convertSplitPayment: (value) => {
        if(value == undefined || !value) {
            return 0;
        }
        if((value).match(/[0-9.]+\,[0-9]{1,2}/g)) {
            const number = (value.split(",").length);
            Logger(value);
            Logger(number);
            Logger("---------------")
            return parseFloat(value.replace(/,/g, '')) / (Math.pow(10, number));
        }
        return parseFloat(value);
    },
    convertPlanDetails: (plan, planExpiryValue) => {
        if(plan.plan_items !== undefined && plan.plan_items) {
            return {
                ...plan
            }
        }
        const currentTime = (new Date()).getTime();
        let expiryTime = currentTime + 1;
        if(planExpiryValue !== undefined && planExpiryValue) {
            expiryTime = (planExpiryValue).getTime();
        }
        if(expiryTime < currentTime) {
            Logger("Expiry Plan Details");
            return {
                ...plan,
                plan_items: 100,
                plan_promotion_no: -1,
                plan_multi_payment: -1,
                plan_inventory: -1,
                plan_user_management: -1
            }
        }
        Logger("Not Expiry Plan Details");
        return {
            ...plan,
            plan_items: -1,
            plan_promotion_no: -1,
            plan_multi_payment: -1,
            plan_inventory: -1,
            plan_user_management: -1
        }
    },
    validateUsage: (usage, items, prices, inventories, sets, categories) => {
        if(usage.type == undefined || !usage.type) {
            return {
                valid: false,
                message: "Type of price usage not exist"
            };
        }
        if(usage.id == undefined || !usage.id) {
            return {
                valid: false,
                message: "Usage not exist"
            };
        }
        if(usage.type === 'inventory') {
            if(inventories[+usage.id] == undefined || !inventories[+usage.id]) {
                return {
                    valid: false,
                    message: "Inventory in set inventory not exist"
                };
            }
        }
        if(usage.type === 'set_meal') {
            if(items[+usage.id] == undefined || !items[+usage.id]) {
                return {
                    valid: false,
                    message: "Item in set meal/item not exist"
                };
            }
            const other = usage.other !== undefined && Filter.isJSON(usage.other) ? JSON.parse(usage.other) : {};
            if(prices[other.prices_name] == undefined || !prices[other.prices_name]) {
                return {
                    valid: false,
                    message: "Price name in set meal/item not exist"
                };
            }
            const catId = other.cat_set_meal !== undefined && 
                other.cat_set_meal[0] !== undefined && 
                categories[other.cat_set_meal[0].id] !== undefined &&
                categories[other.cat_set_meal[0].id].id
                ?  categories[other.cat_set_meal[0].id].id : 0;

            if(categories[+catId] == undefined || !categories[+catId]) {
                return {
                    valid: false,
                    message: "Category in set meal/item not exist"
                };
            }
        }
        if(usage.type === 'group_set_meal') {
            if(sets[+usage.id] == undefined || !sets[+usage.id]) {
                return {
                    valid: false,
                    message: "Group set meal/item not exist"
                };
            }

            const others = usage.list_dish !== undefined && 
                usage.list_dish.others !== undefined &&
                Filter.isJSON(usage.list_dish.others) ? JSON.parse(usage.list_dish.others) : [];

            for(let other of others) {
                const usageOthers = other.usage_other !== undefined && Filter.isJSON(other.usage_other) ? JSON.parse(other.usage_other) : {};
                if(items[other.usage_id] !== undefined == undefined || !items[other.usage_id]) {
                    return {
                        valid: false,
                        message: "Item in set group meal/item not exist"
                    };
                }
                if(prices[usageOthers.prices_name] == undefined || !prices[usageOthers.prices_name]) {
                    return {
                        valid: false,
                        message: "Price name in set group meal/item not exist"
                    };
                }
                const catId = usageOthers.cat_set_meal !== undefined && 
                    usageOthers.cat_set_meal[0] !== undefined && 
                    categories[usageOthers.cat_set_meal[0].id] !== undefined &&
                    categories[usageOthers.cat_set_meal[0].id].id
                    ?  categories[usageOthers.cat_set_meal[0].id].id : 0;

                if(categories[+catId] == undefined || !categories[+catId]) {
                    return {
                        valid: false,
                        message: "Category in set group meal/item not exist"
                    };
                }
            }
        }
        return  {
            valid: true,
            message: "Usage is valid"
        };
    },
    getQuery: (url) => {
        const qs = url.substring(url.indexOf('?') + 1).split('&');
        let result = {};
        const qsLength = qs.length;
        for(let i = 0; i < qsLength; i++){
            qs[i] = qs[i].split('=');
            result[qs[i][0]] = decodeURIComponent(qs[i][1]);
        }
        return result;
    },
    millisToMinutesAndSeconds: (millis) => {
        if(millis == undefined || !millis || millis == 0) {
            return '00:00';
        }
        var minutes = Math.floor(millis / 60000);
        var seconds = ((millis % 60000) / 1000).toFixed(0);
        return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
    }
}

export default Filter;